import { render, staticRenderFns } from "./AddCopyJielongPop.vue?vue&type=template&id=4917d0cd&scoped=true"
import script from "./AddCopyJielongPop.vue?vue&type=script&lang=ts"
export * from "./AddCopyJielongPop.vue?vue&type=script&lang=ts"
import style0 from "./AddCopyJielongPop.vue?vue&type=style&index=0&id=4917d0cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4917d0cd",
  null
  
)

export default component.exports